"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Group;
var _lodash = require("lodash");
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var _Divider = _interopRequireDefault(require("../../Divider"));
/* eslint react/prop-types: 0 */

function Group(props) {
  var children = props.children,
    data = props.data,
    selectProps = props.selectProps;
  var isFiltered = selectProps.inputValue.length > 0;
  var isLastGroup = (0, _lodash.isEqual)(data, (0, _lodash.last)(selectProps.options));
  if (isFiltered) {
    return children;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-metrics": selectProps.dataMetrics.group
  }, /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Group, props), !isLastGroup && /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    variant: "middle",
    className: selectProps.classes.divider
  }));
}